/* delivery-cutoffs.js
 * Greys out / disables delivery-day slots based on the current New Zealand time.
 *
 * ONE SWITCH controls both of your modes:
 *   HIDE_SUNDAY_MODE = false  -> DEFAULT. Sunday works on its normal window,
 *                               Friday cutoff is Monday 11:55PM.
 *   HIDE_SUNDAY_MODE = true   -> Sunday hidden all week,
 *                               Friday cutoff pulled 1 day earlier (Sunday 11:55PM).
 *
 * Just change the one line below. No need to swap files anymore.
 */
(function () {
  'use strict';

  // ==== THE ONLY LINE YOU CHANGE ==========================================
  var HIDE_SUNDAY_MODE = true; // Holiday wk: Friday cut-off Sun 11:55PM. Set back to false from Tue 10 Nov 2026.
  // ========================================================================

  if (window.deliveryElementsManager) return;

  // Minutes-since-start-of-week. Sunday 00:00 = 0, Saturday 23:59 = 10079.
  var MIN = function (day, hour, minute) { return day * 1440 + hour * 60 + minute; };

  // Each window is disabled when: start <= end ? (start <= now < end)
  //                                            : (now >= start || now < end)  // wraps over Sat->Sun
  var SLOTS = [
    {
      name: 'wednesday',
      selectors: '.itbmnCq2cbcUDPCHV, .id57tYJ1nzrv30UZx, .i2Ay6Y9DbLqrfasPq, .iMmbB7MTi9sHI4u4A',
      // Sat 11:55PM -> Wed 1:00AM
      windows: [{ start: MIN(6, 23, 55), end: MIN(3, 1, 0) }]
    },
    {
      name: 'friday',
      selectors: '.ioyUAQrEuwdhiZgZN, .iqqg6D161pqig1lzz',
      button: '.irlNYEayc07WwCwPV',
      // default: Mon 11:55PM -> end of Fri | hide-sunday: Sun 11:55PM -> end of Fri
      windows: [{
        start: HIDE_SUNDAY_MODE ? MIN(0, 23, 55) : MIN(1, 23, 55),
        end: MIN(6, 0, 0) // Saturday 00:00 = through Friday 11:59PM
      }]
    },
    {
      // Was Sunday: same Instant elements now hold the Thursday buttons.
      name: 'thursday',
      selectors: '.iEl6N2aejaGmvOKCM, .iNEHJFT0rliRXb5qR',
      // Sun 11:55PM -> Thu 1:00AM
      windows: [{ start: MIN(0, 23, 55), end: MIN(4, 1, 0) }]
    }
  ];

  var intervalId = null;
  var observer = null;

  function nowMinuteOfWeek() {
    var parts = new Intl.DateTimeFormat('en-NZ', {
      timeZone: 'Pacific/Auckland',
      weekday: 'long', hour: 'numeric', minute: 'numeric', hour12: false
    }).formatToParts(new Date());

    var dayMap = { Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6 };
    var day = 0, hour = 0, minute = 0;

    parts.forEach(function (p) {
      if (p.type === 'weekday') day = dayMap[p.value];
      else if (p.type === 'hour') hour = parseInt(p.value, 10) % 24; // 24 -> 0 guard
      else if (p.type === 'minute') minute = parseInt(p.value, 10);
    });

    return MIN(day, hour, minute);
  }

  function inWindow(now, w) {
    return w.start <= w.end ? (now >= w.start && now < w.end)
                           : (now >= w.start || now < w.end);
  }

  function slotDisabled(slot, now) {
    if (slot.always) return true;
    return slot.windows.some(function (w) { return inWindow(now, w); });
  }

  function setState(nodeList, disabled, cls) {
    nodeList.forEach(function (el) {
      el.classList.toggle(cls, disabled);
      if (disabled) el.setAttribute('aria-disabled', 'true');
      else el.removeAttribute('aria-disabled');
    });
  }

  function update() {
    var now = nowMinuteOfWeek();
    SLOTS.forEach(function (slot) {
      var disabled = slotDisabled(slot, now);
      setState(document.querySelectorAll(slot.selectors), disabled, 'delivery-slot--disabled');
      if (slot.button) {
        setState(document.querySelectorAll(slot.button), disabled, 'delivery-slot--disabled-btn');
      }
    });
  }

  function injectStyles() {
    if (document.getElementById('delivery-cutoffs-styles')) return;
    var style = document.createElement('style');
    style.id = 'delivery-cutoffs-styles';
    style.textContent =
      '.delivery-slot--disabled{opacity:.3!important;pointer-events:none!important;cursor:not-allowed!important;}' +
      '.delivery-slot--disabled-btn{opacity:.5!important;pointer-events:none!important;cursor:not-allowed!important;}';
    document.head.appendChild(style);
  }

  function init() {
    injectStyles();
    update();

    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(update, 60000);

    var debounce;
    observer = new MutationObserver(function (mutations) {
      var added = mutations.some(function (m) { return m.addedNodes.length > 0; });
      if (!added) return;
      clearTimeout(debounce);
      debounce = setTimeout(update, 100);
    });
    observer.observe(document.body, { childList: true, subtree: true });

    window.deliveryElementsManager = {
      mode: HIDE_SUNDAY_MODE ? 'hide-sunday' : 'default',
      update: update,
      destroy: function () {
        if (intervalId) { clearInterval(intervalId); intervalId = null; }
        if (observer) { observer.disconnect(); observer = null; }
        delete window.deliveryElementsManager;
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();